<template>
    <div v-if="this.status" class="alert fade show mt-4 mt-md-0" :class="{ 'alert-success' : this.status === 'success' , 'alert-danger' : this.status === 'error', 'alert-warning' : this.status === 'warning'}" role="alert">
        {{ message }}
        <button type="button" class="close" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>
<script>
   export default {
       props: ['status', 'message', 'can_close'],
       methods: {
           close: function() {
               this.$emit('dismiss')
           }
       }
   }
</script>



// WEBPACK FOOTER //
// resources/js/components/common/Alert.vue